/*eslint-disable*/
// reactstrap components
import { site_name } from "helpers/utils";
import { Row, Col, Nav, NavItem, NavLink } from "reactstrap";

const Footer = () => {
  // const user = localStorage.getItem("user");
  // const userData = JSON.parse(user);

  // const {companyName} = userData

  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-xl-between d-md-none d-block">
        <Col xl="6">
          <div className="copyright text-center text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="#"
              rel="noopener noreferrer"
              target="_blank"
            >
              {site_name}
              {/* {companyName} */}
            </a>
          </div>
        </Col>

        {/* <Col xl="6">
          <Nav className="nav-footer justify-content-center justify-content-xl-end">
            <NavItem>
              <NavLink
                href="#"
                rel="noopener noreferrer"
                target="_blank"
              >
               {companyName}
              </NavLink>
            </NavItem>

          </Nav>
        </Col> */}
      </Row>
    </footer>
  );
};

export default Footer;
